import { FlexHoursAction, FlexHoursState } from 'pages/Time/_store';
import * as R from 'remeda';
import { timeUtility } from 'utility';

const initialState: FlexHoursState = {
  selectedDates: [],
  chartMode: 'exploration',
  chartExploreDate: timeUtility.convertDay('year', timeUtility.getToday()),
  chartSelectedDateType: 'year',
  chartFilter: {},
  pivotById: {},
};

const flexHoursReducer = (
  state: FlexHoursState = initialState,
  action: FlexHoursAction,
): FlexHoursState => {
  switch (action.type) {
    case 'page/flexHours/TOGGLE_PIVOT': {
      let pivotById = R.clone(state.pivotById);

      const pivotted = R.isTruthy(pivotById[action.payload.id]);
      if (pivotted) pivotById = R.omit(pivotById, [action.payload.id]);
      else pivotById[action.payload.id] = true;

      return R.set(state, 'pivotById', pivotById);
    }
    case 'page/flexHours/SET_SELECTED_DATES': {
      const selectedDates = action.payload;
      return R.set(state, 'selectedDates', selectedDates);
    }

    case 'page/flexHours/SET_CHART_MODE':
      return R.set(state, 'chartMode', action.payload);
    case 'page/flexHours/SET_CHART_SELECTED_DATE_TYPE':
      return R.set(state, 'chartSelectedDateType', action.payload);
    case 'page/flexHours/SET_CHART_EXPLORE_DATE_HISTORY':
      return R.set(state, 'chartExploreDate', action.payload);
    case 'page/flexHours/SET_CHART_FILTER':
      return R.set(state, 'chartFilter', action.payload);
    default:
      return state;
  }
};

export default flexHoursReducer;
